import { BusinessClockStatus } from './core/time/business-clock-ui';
import { AfterViewInit, Component, OnDestroy, inject } from '@angular/core';
import { ModalInteractionManager } from './shared/utils/modal-interaction-manager';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { TrackingService } from './core/services/tracking.service';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, BusinessClockStatus],
    template: '<app-business-clock-status></app-business-clock-status><router-outlet></router-outlet>'
})
export class AppComponent implements AfterViewInit, OnDestroy {
  private readonly modalInteractions = new ModalInteractionManager();
  ngAfterViewInit(): void { this.modalInteractions.start(); }
  ngOnDestroy(): void { this.modalInteractions.stop(); }
  constructor() {
    void inject(TrackingService).initializeCommon();
    const translate = inject(TranslateService);
    translate.setFallbackLang('ja');
    translate.use('ja');
  }
}
